import React from 'react';

const Loading = () => (
  <div className='lc-loading'>
    Loading. Please wait...
  </div>
);

export default Loading;